import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useVolunteerAuth } from '../contexts/VolunteerAuthContext';

function VolunteerProtectedRoute() {
  const { currentVolunteer, loading } = useVolunteerAuth();
  const { orgId } = useParams();

  if (loading) {
    return (
      <div className="bb-loading-screen">
        <div className="bb-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!currentVolunteer) {
    return <Navigate to={`/BespokeBridge/${orgId}/volunteer/login`} replace />;
  }

  if (orgId && currentVolunteer.orgId !== orgId) {
    return <Navigate to={`/BespokeBridge/${orgId}/volunteer/login`} replace />;
  }

  return <Outlet />;
}

export default VolunteerProtectedRoute;
